import Cookies from 'js-cookie';
import { isBrowser } from '@/utils/environment';

const previewModeKey = 'preview-mode-v2';
const cachedPreviewModeValues: { [key: string]: boolean } = {};

export enum PreviewModeType {
  Blog = 'Blog',
  Calendar = 'Calendar',
  HomePage = 'HomePage',
}

const getPreviewMode = (previewModeType: PreviewModeType = PreviewModeType.Blog): boolean => {
  if (!isBrowser()) {
    return false;
  }
  if (cachedPreviewModeValues[previewModeType] !== undefined) {
    return cachedPreviewModeValues[previewModeType];
  }

  const previewMode: boolean = Cookies.get(getPreviewModeKey(previewModeType)) === 'true';

  cachedPreviewModeValues[previewModeType] = previewMode;
  return previewMode;
};
export const turnPreviewModeOff = (previewModeType: PreviewModeType = PreviewModeType.Blog) => {
  Cookies.set(getPreviewModeKey(previewModeType), 'false');
  window.location.reload();
};

const getPreviewModeKey = (previewModeType: PreviewModeType = PreviewModeType.Blog): string => {
  if (previewModeType == PreviewModeType.Blog) return previewModeKey;
  else return previewModeKey + '-' + previewModeType;
};

export default getPreviewMode;
